// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-note-wrapper{position:fixed;bottom:0;left:550px;width:calc(100% - 550px)}", ""]);
// Exports
module.exports = exports;
